var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-office-docx"},[_c('div',{ref:"rootRef",staticClass:"vue-office-docx-main",attrs:{"id":"vue-office-docx-main"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }